// DEFCON TERMINAL - Constants

// DEFCON Levels
export const DEFCON_LEVELS = {
  1: {
    name: 'COCKED PISTOL',
    description: 'Nuclear war imminent or in progress',
    color: '#ff0000',
  },
  2: {
    name: 'FAST PACE',
    description: 'Armed forces ready to deploy in 6 hours',
    color: '#ff6600',
  },
  3: {
    name: 'ROUND HOUSE',
    description: 'Armed forces ready to mobilize in 15 minutes',
    color: '#ffcc00',
  },
  4: {
    name: 'DOUBLE TAKE',
    description: 'Increased intelligence and security measures',
    color: '#00cc00',
  },
  5: {
    name: 'FADE OUT',
    description: 'Normal peacetime readiness',
    color: '#00ff00',
  },
} as const;

// Phone number prefixes (fictional - 555 is reserved for fiction)
export const PHONE_PREFIX = '555-01';

// System names
export const SYSTEM_NAMES = {
  'sarn-west': {
    name: 'S.A.R.N.',
    fullName: 'Strategic Automated Response Network',
    subtitle: 'Western Theater Command',
    accessPrompt: 'LOGIN REQUIRED',
  },
  'sarn-east': {
    name: 'ПЕРИМЕТР-2',
    englishName: 'PERIMETR-2',
    fullName: 'Automated Strategic Response System',
    russianFullName: 'АВТОМАТИЗИРОВАННАЯ СИСТЕМА СТРАТЕГИЧЕСКОГО ОТВЕТА',
    accessPrompt: 'ENTER ACCESS CODE',
  },
  'phantom-directive': {
    name: 'PHANTOM DIRECTIVE',
    fullName: 'Special Activities Coordination Center',
    accessPrompt: 'WELCOME, OPERATIONS COORDINATOR',
  },
  'red-shadow': {
    name: 'КРАСНАЯ ТЕНЬ',
    englishName: 'RED SHADOW',
    fullName: 'Directorate S - Special Operations',
    accessPrompt: 'ДОБРО ПОЖАЛОВАТЬ, ТОВАРИЩ КООРДИНАТОР',
  },
} as const;

// Terminal colors
export const TERMINAL_COLORS = {
  green: {
    primary: '#33ff33',
    dim: '#1a8c1a',
    bright: '#66ff66',
    background: '#0a0a0a',
  },
  amber: {
    primary: '#ffb000',
    dim: '#8c6000',
    bright: '#ffc633',
    background: '#0a0800',
  },
  white: {
    primary: '#e0e0e0',
    dim: '#808080',
    bright: '#ffffff',
    background: '#0a0a0a',
  },
} as const;

// Timing constants
export const TIMING = {
  typingSpeed: 30, // ms per character
  fastTypingSpeed: 10,
  slowTypingSpeed: 50,
  lineDelay: 100, // ms between lines
  connectionDelay: 2000, // ms for connection animation
  warDialerDelay: 500, // ms between phone number attempts
  saveInterval: 30000, // Auto-save every 30 seconds
  sessionTimeout: 86400000, // 24 hours in ms
} as const;

// Scoring constants
export const SCORING = {
  baseDecisionPoints: 10,
  scenarioCompletePoints: 100,
  intelligenceGatherPoints: 5,
  easterEggPoints: 50,
  multiplePathBonus: 25,
  speedrunThreshold: 300, // 5 minutes in seconds
} as const;

// ASCII art dimensions
export const ASCII_DIMENSIONS = {
  terminalWidth: 80,
  terminalHeight: 24,
  mapWidth: 60,
  mapHeight: 20,
} as const;

// Hidden commands (easter eggs)
export const HIDDEN_COMMANDS = [
  'JOSHUA',
  'THERMONUCLEAR',
  'DEFCON0',
  'BACKDOOR',
  'WOPR',
  'FALKEN',
  'GLOBALTHERMONUCLEARWAR',
] as const;

// Audio files
export const AUDIO_FILES = {
  modemConnect: '/audio/modem-connect.mp3',
  modemHandshake: '/audio/modem-handshake.mp3',
  terminalBeep: '/audio/terminal-beep.mp3',
  alertKlaxon: '/audio/alert-klaxon.mp3',
  keypress: '/audio/keypress.mp3',
  error: '/audio/error.mp3',
  success: '/audio/success.mp3',
} as const;

// Game version
export const GAME_VERSION = '1.0.0';
export const GAME_TITLE = 'DEFCON TERMINAL';
export const GAME_YEAR = 1984;
